import { render, staticRenderFns } from "./HideMobile.vue?vue&type=template&id=fd982d8a&scoped=true"
import script from "./HideMobile.vue?vue&type=script&lang=js"
export * from "./HideMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd982d8a",
  null
  
)

export default component.exports